import { FilterApiData } from "../../utility/constants/common-constants";
import { Category, FilterPayload, Message } from "../../utility/interfaces/educationLibraryInterfaces";

export const mapDefaultSwitchesFromFilters = (
  messages: Message[],
  filters: FilterPayload
): Record<string, boolean> => {
  return Object.fromEntries(
    messages.map(msg => {
      const content = msg.defaultContent;

      if (content === FilterApiData.FILTER_POINTS_ELIGIBLE) {
        return [content, filters.rewardsEligibility];
      }

      if (content === FilterApiData.FILTER_HIDE_COMPLETED) {
        return [content, filters.hideCompleted];
      }

      return [content, false];
    })
  );
};

export const mapDefaultCheckboxesFromFilters = (categories: Category[], filters: FilterPayload): Record<string, string[]> => {
  return Object.fromEntries(
    categories.map(cat => {
      const key = cat.categoryCode === FilterApiData.FILTER_TYPE
        ? FilterApiData.FILTER_POST_CONTENT_TYPE
        : cat.categoryCode === FilterApiData.FILTER_PHASE
          ? FilterApiData.FILTER_POST_TRIMESTER
          : FilterApiData.FILTER_POST_CATEGORY;

      const selected = filters[key as keyof FilterPayload] as string[];
      return [cat.categoryCode, selected && selected.length > 0 ? selected : [FilterApiData.SELECT_ALL]];
    })
  );
};

export const mapUIStateToFilters = (
  switches: Record<string, boolean>,
  checkboxes: Record<string, string[]>,
  categories: Category[],
  defaultFilters: FilterPayload
): FilterPayload => {

  const cleanedCheckboxes: Record<string, string[]> = {};

  for (const [category, selected] of Object.entries(checkboxes)) {
    const available = categories
      .find(cat => cat.categoryCode === category)?.messages
      .filter(m => m.defaultContent !== FilterApiData.SELECT_ALL)
      .map(m => m.defaultContent) || [];

    const filtered = selected.filter(label => label !== FilterApiData.SELECT_ALL);

    cleanedCheckboxes[category] =
      filtered.length === 0 || filtered.length === available.length ? [] : filtered;
  }

  const mappedFilters: FilterPayload = {
    rewardsEligibility: switches[FilterApiData.FILTER_POINTS_ELIGIBLE],
    hideCompleted: switches[FilterApiData.FILTER_HIDE_COMPLETED],
    contentType: cleanedCheckboxes[FilterApiData.FILTER_TYPE] || [],
    trimester: cleanedCheckboxes[FilterApiData.FILTER_PHASE] || [],
    category: defaultFilters.category.length
      ? defaultFilters.category
      : cleanedCheckboxes[FilterApiData.FILTER_CATEGORY] || [],
  };

  return mappedFilters;
};

export const areFiltersEqual = (currentFilter: FilterPayload, appliedFilter: FilterPayload): boolean => {
  return (
    currentFilter.rewardsEligibility === appliedFilter.rewardsEligibility &&
    currentFilter.hideCompleted === appliedFilter.hideCompleted &&
    JSON.stringify(currentFilter.contentType) === JSON.stringify(appliedFilter.contentType) &&
    JSON.stringify(currentFilter.trimester) === JSON.stringify(appliedFilter.trimester) &&
    JSON.stringify(currentFilter.category) === JSON.stringify(appliedFilter.category)
  );
};

